import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_NOT_DEMO_TCA_4 = {
  title:
    "Harness the power of machine learning \nfor automated fault healing in your \nnetwork through closed-loop automation",
  subtitle: "Network operation team",
  text: "Collect, extract, filter, and correlate network events across\n multiple domains with a policy-driven engine. Detect anomalies\n and elevate precision with use case specific ML models and\n pipelines for self-optimizing fault isolation.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_316"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage("ILO_314");
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ILO/TCA/TCA_NOT_Demo_4_1.png",
          imageStyle: { position: "absolute", top: "135px", right: "-83px" },
        },
      ]}
      conversationStyle={{ width: "auto" }}
      pageNumber={"ILO_315"}
    />
  ),
};
